import { useState } from "react";
import type { MovieItem } from "@/mocks/movies";

export default function EpisodeSection({ item }: { item: MovieItem }) {
  const isSeries = item.category === "电视剧" && item.episodes.length > 0;
  const [active, setActive] = useState(0);

  if (!isSeries) {
    return (
      <section className="mt-8">
        <h2 className="font-heading text-lg md:text-xl font-bold text-foreground-950 flex items-center gap-2 mb-4">
          <span className="w-1 h-5 rounded-full bg-accent-500 inline-block"></span>
          影片信息
        </h2>
        <div className="rounded-lg bg-background-100 border border-background-200 p-5 text-sm text-foreground-700 leading-relaxed">
          本片为电影作品，片长与上映信息以官方发布为准。以上剧情简介为该影片的整体故事概述，具体细节请以正式内容为准。
        </div>
      </section>
    );
  }

  return (
    <section className="mt-8">
      <div className="flex items-center justify-between gap-3 mb-4">
        <h2 className="font-heading text-lg md:text-xl font-bold text-foreground-950 flex items-center gap-2">
          <span className="w-1 h-5 rounded-full bg-accent-500 inline-block"></span>
          剧集列表
        </h2>
        <span className="text-xs md:text-sm text-foreground-500">共 {item.episodes.length} 集 · {item.updateStatus}</span>
      </div>

      <div className="flex flex-row flex-nowrap gap-2 overflow-x-auto pb-2 no-scrollbar md:flex-wrap">
        {item.episodes.map((ep, i) => (
          <button
            key={ep}
            type="button"
            onClick={() => setActive(i)}
            className={`whitespace-nowrap shrink-0 px-3 py-1.5 rounded-md text-sm transition-colors cursor-pointer ${
              i === active
                ? "bg-accent-500 text-primary-950 font-semibold"
                : "bg-background-100 text-foreground-600 hover:bg-accent-100 hover:text-accent-800"
            }`}
          >
            {i + 1}
          </button>
        ))}
      </div>

      <div className="mt-4 rounded-lg bg-background-100 border border-background-200 p-5">
        <div className="flex items-center gap-2 mb-2">
          <span className="w-7 h-7 flex items-center justify-center rounded-md bg-primary-500 text-background-50 text-xs font-bold">
            {active + 1}
          </span>
          <h3 className="font-heading text-base font-semibold text-foreground-950">{item.episodes[active]}</h3>
        </div>
        <p className="text-sm text-foreground-600 leading-relaxed">
          本集围绕“{item.title}”的主线剧情推进：{item.synopsis.slice(0, 60)}……后续情节将逐步揭开人物之间的关联与矛盾，更多精彩内容请持续关注更新。
        </p>
      </div>
    </section>
  );
}